import React from 'react';
import { Card } from 'glints-aries/es/@next';
import { Redirect, useHistory } from 'react-router';

import { initializeSession } from '../../../../../actions/session';
import { useTypedApolloClient } from '../../../../../apollo-client';
import { getJobCreatePath } from '../../../../../common/employerJobPaths';
import useShouldShowWhatsappVerification from '../../../../../common/hooks/useShouldShowWhatsappVerification';
import { useShowCreateCompanySuccess } from '../../../../../common/hooks/useShowCreateCompanySuccess';
import { InputNumberStep } from '../../../../../components/Modal/WhatsappVerificationModal/components/InputNumberStep/InputNumberStep';
import { InputNumberModalFooter } from '../../../../../components/Modal/WhatsappVerificationModal/components/ModalFooter/components/InputNumberModalFooter';
import { Variant } from '../../../../../components/Modal/WhatsappVerificationModal/components/VerificationSuccessStep/constants';
import { WhatsappVerificationModal } from '../../../../../components/Modal/WhatsappVerificationModal/WhatsappVerificationModal';
import { WhatsappVerificationStep } from '../../../../../components/WhatsappVerification/types';
import { useWhatsappVerificationContext } from '../../../../../components/WhatsappVerification/WhatsappVerificationContext/WhatsappVerificationContext';
import { withWhatsappVerificationContextProvider } from '../../../../../components/WhatsappVerification/WhatsappVerificationContext/withWhatsappVerificationContextProvider';
import { getUser } from '../../../../../selectors/user';
import { useAppDispatch, useAppSelector } from '../../../../../store';
import { ModalHeaders } from './constants';
import { StyledWrapper } from './WhatsappVerificationForm.sc';

const Component = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const user = useAppSelector(getUser);
  const apolloClient = useTypedApolloClient();
  useShowCreateCompanySuccess();

  const { currentStep } = useWhatsappVerificationContext();
  const isMandatory = useShouldShowWhatsappVerification();

  const redirectToJobCreation = () => {
    dispatch(initializeSession(apolloClient) as any);
    history.push(getJobCreatePath());
  };

  if (user.isWhatsappVerified) {
    dispatch(initializeSession(apolloClient) as any);
    return <Redirect to={getJobCreatePath()} />;
  }

  const handleModalClose = () => {
    if (currentStep === WhatsappVerificationStep.VerificationSuccess) {
      return redirectToJobCreation();
    }
  };

  return (
    <>
      <StyledWrapper>
        <Card
          customActions={
            <InputNumberModalFooter
              {...(!isMandatory && {
                onClose: redirectToJobCreation,
                closeButtonText: {
                  id: 'interactive-skip-for-now',
                  defaultMessage: 'Skip for now',
                },
              })}
            />
          }
        >
          <Card.Section>
            <InputNumberStep />
          </Card.Section>
        </Card>
      </StyledWrapper>
      <WhatsappVerificationModal
        isOpen={currentStep !== WhatsappVerificationStep.InputNumber}
        onClose={handleModalClose}
        successButtonText={{ id: 'interactive-done', defaultMessage: 'Done' }}
        successStepVariant={Variant.NOTIFICATION}
        closeButtonText={{
          id: 'interactive-skip-for-now',
          defaultMessage: 'Skip for now',
        }}
        showCloseButton={
          currentStep !== WhatsappVerificationStep.VerificationSuccess
        }
        headers={ModalHeaders}
      />
    </>
  );
};

export const WhatsappVerificationForm = React.memo(
  withWhatsappVerificationContextProvider(Component)
);
